import PropTypes from 'prop-types';
import withCollapsibleState from '../../decorators/withCollapsibleState';
import { Collapsible } from './Collapsible';
import CollapsibleLabel from './CollapsibleLabel';

export const CollapsibleItem = ({
  handleMoreClick,
  shouldShowMore,
  children,
  moreText,
  lessText,
  labelStyle,
  className,
}) => {
  if (!children) {
    return null;
  }

  return (
    <>
      <CollapsibleLabel
        shouldShowMore={shouldShowMore}
        onMoreInfoClick={handleMoreClick}
        labelStyle={labelStyle}
        className={className}
        lessText={lessText}
        moreText={moreText}
      />
      <Collapsible data-testid="collapsibleItemAccordion" isOpen={shouldShowMore}>
        {children}
      </Collapsible>
    </>
  );
};

CollapsibleItem.propTypes = {
  handleMoreClick: PropTypes.func.isRequired,
  shouldShowMore: PropTypes.bool.isRequired,
  children: PropTypes.node,
  moreText: PropTypes.node.isRequired,
  lessText: PropTypes.node.isRequired,
  labelStyle: PropTypes.object,
  className: PropTypes.string,
};

export default withCollapsibleState(CollapsibleItem);
